export default __webpack_public_path__ + "static/media/snapdc_logo.b1288e8d.png";